import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bbcb5d0c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/login-lanhu.css?vue&type=style&index=0&id=bbcb5d0c&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=bbcb5d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb5d0c",
  null
  
)

export default component.exports